import React, { forwardRef } from "react";
import parse from "html-react-parser";

const CustomToast = forwardRef(
  ({ title, message, variant, textLink = "", clickOnText, snackbarKey, closeSnackbar, type = "normal" /* normal / display_title */ }: any, ref: any) => {
    const containerStyles:any = {
      success: { backgroundColor: "#E6F9F1", border: "1px solid #06C270" },
      error: { backgroundColor: "#FDE9E9", border: "1px solid #F33D62" },
      loading: { backgroundColor: "#F9F5E6", border: "1px solid #9B5F05" },
    };

    const toastIcons: any = {
      success: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="23"
          viewBox="0 0 22 23"
          fill="none"
        >
          <g clipPath="url(#clip0_8575_19490)">
            <path
              d="M8.25052 15.35L4.40052 11.5L3.11719 12.7833L8.25052 17.9166L19.2505 6.91663L17.9672 5.6333L8.25052 15.35Z"
              fill="#059B5A"
            />
          </g>
          <defs>
            <clipPath id="clip0_8575_19490">
              <rect
                width="22"
                height="22"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      error: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <g clipPath="url(#clip0_8575_19508)">
            <path
              d="M11 15.5H13V17.5H11V15.5ZM11 7.5H13V13.5H11V7.5ZM11.99 2.5C6.47 2.5 2 6.98 2 12.5C2 18.02 6.47 22.5 11.99 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 11.99 2.5ZM12 20.5C7.58 20.5 4 16.92 4 12.5C4 8.08 7.58 4.5 12 4.5C16.42 4.5 20 8.08 20 12.5C20 16.92 16.42 20.5 12 20.5Z"
              fill="#F00C0C"
            />
          </g>
          <defs>
            <clipPath id="clip0_8575_19508">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      loading: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <mask
            id="mask0_9290_3938"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25"
          >
            <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_9290_3938)">
            <path
              d="M12 22.5C10.6333 22.5 9.34167 22.2375 8.125 21.7125C6.90833 21.1875 5.84583 20.4708 4.9375 19.5625C4.02917 18.6542 3.3125 17.5917 2.7875 16.375C2.2625 15.1583 2 13.8667 2 12.5C2 11.1167 2.2625 9.82083 2.7875 8.6125C3.3125 7.40417 4.02917 6.34583 4.9375 5.4375C5.84583 4.52917 6.90833 3.8125 8.125 3.2875C9.34167 2.7625 10.6333 2.5 12 2.5C12.2833 2.5 12.5208 2.59583 12.7125 2.7875C12.9042 2.97917 13 3.21667 13 3.5C13 3.78333 12.9042 4.02083 12.7125 4.2125C12.5208 4.40417 12.2833 4.5 12 4.5C9.78333 4.5 7.89583 5.27917 6.3375 6.8375C4.77917 8.39583 4 10.2833 4 12.5C4 14.7167 4.77917 16.6042 6.3375 18.1625C7.89583 19.7208 9.78333 20.5 12 20.5C14.2167 20.5 16.1042 19.7208 17.6625 18.1625C19.2208 16.6042 20 14.7167 20 12.5C20 12.2167 20.0958 11.9792 20.2875 11.7875C20.4792 11.5958 20.7167 11.5 21 11.5C21.2833 11.5 21.5208 11.5958 21.7125 11.7875C21.9042 11.9792 22 12.2167 22 12.5C22 13.8667 21.7375 15.1583 21.2125 16.375C20.6875 17.5917 19.9708 18.6542 19.0625 19.5625C18.1542 20.4708 17.0958 21.1875 15.8875 21.7125C14.6792 22.2375 13.3833 22.5 12 22.5Z"
              fill="#9B5F05"
            />
          </g>
        </svg>
      ),
    };

    const titleStyles: any = {
      success: { color: "#343A3D" },
      error: { color: "#343A3D" },
      loading: { color: "#9B5F05" },
    };

    const messageStyles: any = {
      success: { color: "#059B5A" },
      error: { color: "#F00C0C" },
      loading: { color: "#9B5F05" },
    };

    const closeIcons: any = {
      success: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
        >
          <g clipPath="url(#clip0_9379_58)">
            <path
              d="M15.8346 5.84175L14.6596 4.66675L10.0013 9.32508L5.34297 4.66675L4.16797 5.84175L8.8263 10.5001L4.16797 15.1584L5.34297 16.3334L10.0013 11.6751L14.6596 16.3334L15.8346 15.1584L11.1763 10.5001L15.8346 5.84175Z"
              fill="#059B5A"
            />
          </g>
          <defs>
            <clipPath id="clip0_9379_58">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      error: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
        >
          <g clipPath="url(#clip0_9379_2072)">
            <path
              d="M15.8346 5.84175L14.6596 4.66675L10.0013 9.32508L5.34297 4.66675L4.16797 5.84175L8.8263 10.5001L4.16797 15.1584L5.34297 16.3334L10.0013 11.6751L14.6596 16.3334L15.8346 15.1584L11.1763 10.5001L15.8346 5.84175Z"
              fill="#F00C0C"
            />
          </g>
          <defs>
            <clipPath id="clip0_9379_2072">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      loading: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
        >
          <g clipPath="url(#clip0_9379_1011)">
            <path
              d="M15.8346 5.84175L14.6596 4.66675L10.0013 9.32508L5.34297 4.66675L4.16797 5.84175L8.8263 10.5001L4.16797 15.1584L5.34297 16.3334L10.0013 11.6751L14.6596 16.3334L15.8346 15.1584L11.1763 10.5001L15.8346 5.84175Z"
              fill="#9B5F05"
            />
          </g>
          <defs>
            <clipPath id="clip0_9379_1011">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    };
    
    return (
      <div
        ref={ref}
        className="px-4 py-[0.375rem] flex items-center gap-3 rounded-[0.25rem] alu-toast-box-shadow sm:max-w-[500px]"
        style={{ ...containerStyles[variant] }}
      >
        <span className="shrink-0">{toastIcons[variant]}</span>
        <div className={`${textLink ? "flex-1 sm:flex items-center justify-between gap-3" : "flex-1"}`}>
          <h5
            className="text-base font-medium break-all"
            style={{ ...titleStyles[variant] }}
          >
            {type === "display_title"
              ? (!!title && typeof title === 'string' ? parse(title) : title)
              : (!!message && typeof message === 'string' ? parse(message) : message)}
          </h5>
          {type == "display_title" && <p
            className="text-sm font-normal"
            style={{ ...messageStyles[variant] }}
          >
            {parse(message)}
          </p>}
          {textLink && (
          <p
            className="text-[13px] font-normal cursor-pointer mt-2 sm:whitespace-nowrap sm:mt-0"
            style={{ ...messageStyles[variant] }}
            onClick={clickOnText}
          >
            {textLink}
          </p>
          )}
        </div>
        <button onClick={() => closeSnackbar(snackbarKey)} className="shrink-0">
          {closeIcons[variant]}
        </button>
      </div>
    );
  }
);

export default CustomToast;
